import React, { Component } from 'react';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import Table from '../table/Table';
import TableBody from '../table/Body';
import { RequirementItem } from './RequirementItem';

class ProductionRequirementsWidget extends Component {
  state = {
    saved: false
  }

  requirements = {
    not_sold_without_post: {
      title: 'Do not sell without post',
      description: 'Raw audio may not be delivered as recorded - it has to be post produced first.'
    },
    book_external_studio: {
      title: 'Book external studio',
      description: 'This talent cannot record for us at home - book an external studio.'
    }
  }

  handleSave = () => {
    this.setSaved();
  }

  setSaved() {
    this.setState({ saved: true });
    setTimeout(this.unsetSaved, 2000);
  }

  unsetSaved = () => {
    this.setState({ saved: false });
  }

  render() {
    const { supplier } = this.props;

    return (
      <Panel>
        <Header title="Production requirements" onSave={this.handleSave} saved={this.state.saved} />
        <PanelBody>
          <Table margin="0">
            <TableBody>
              {Object.entries(this.requirements).map(([key, { title, description }]) => (
                <RequirementItem
                  key={key}
                  supplierId={supplier.uid}
                  fieldKey={key}
                  title={title}
                  description={description}
                  value={supplier[key]}
                  handleSave={this.handleSave}
                />
              ))}
            </TableBody>
          </Table>
        </PanelBody>
      </Panel>
    );
  }
}

export { ProductionRequirementsWidget };
